import React, { useState } from "react";
import { ArrowRightIcon, ChevronRightIcon, TargetIcon } from "lucide-react";
import { situations } from "../data/landing";
export function SituationFinder() {
  const [activeId, setActiveId] = useState(situations[0].id);
  const active = situations.find(s => s.id === activeId) ?? situations[0];
  return <section className="section" id="finder" aria-labelledby="finder-heading" data-id="element-234" data-mp="2pf077mv11f5r">
      <div className="shell" data-id="element-235" data-mp="2leg84dqw81gz">
        <div className="section-intro" data-id="element-236" data-mp="2lfrg6prdfvdw">
          <p className="eyebrow" data-id="element-237" data-mp="2gnriz52orgl0">WHERE TO START</p>
          <h2 id="finder-heading" data-id="element-238" data-mp="2glwy1qrezogx">
            What are you hearing <span data-id="element-239" data-mp="2bnve73m5zl4e">in your team's conversations?</span>
          </h2>
          <p data-id="element-240" data-mp="2bm25zjvwksua">Pick the situation that sounds most familiar to see which practice fits it.</p>
        </div>
        <div className="finder-grid" data-id="element-241" data-mp="26nh5djcqo75b">
          <div className="finder-options" role="group" aria-label="Choose a situation" data-id="element-242" data-mp="21qgyx7bz92do">
            {situations.map(situation => <button key={situation.id} type="button" aria-pressed={situation.id === activeId} onClick={() => setActiveId(situation.id)} data-id="element-243" data-mp="1xpf7vds7rwms">
                {situation.label}
                <ChevronRightIcon size={18} aria-hidden="true" data-id="element-244" data-mp="erdm4kvnz83v" />
              </button>)}
          </div>
          <div className="finder-result" aria-live="polite" data-id="element-245" data-mp="jqzzqvfemqd7">
            <p className="eyebrow" data-id="element-246" data-mp="17fj7n9ujl14r">RECOMMENDED PRACTICE</p>
            <h3 data-id="element-247" data-mp="17g2ftyue4b5l">{active.title}</h3>
            <p className="finder-workshop" data-id="element-248" data-mp="1cem2k1gt5qz0">{active.workshop}</p>
            <p className="finder-desc" data-id="element-249" data-mp="1ce41mrj7aokr">{active.description}</p>
            <div className="outcome" data-id="element-250" data-mp="yfmfuzcuvm5h">
              <TargetIcon size={18} aria-hidden="true" data-id="element-251" data-mp="yel40so0mvmp" />
              <div data-id="element-252" data-mp="12foipbubulmc">
                <strong data-id="element-253" data-mp="12f4ytpl49n5o">WHAT YOU'LL PRACTICE TOWARD</strong>
                <p data-id="element-254" data-mp="3j5bt57xwuzw2">{active.outcome}</p>
              </div>
            </div>
            <a className="text-link" href="#workshops" data-id="element-255" data-mp="3j76cihtjajy1">
              {active.pairWith} <ArrowRightIcon size={15} aria-hidden="true" data-id="element-256" data-mp="3n88ev7iqzc48" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}